import React, { useContext } from 'react';
import { AuthContext } from '../App';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, XCircle, LogOut, RefreshCw, Car } from 'lucide-react';

export default function PendingApproval() {
  const { user, logout } = useContext(AuthContext);
  const rejected = user?.approval_status === 'rejected';

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Card className="bg-gray-900 border-gray-800 max-w-md w-full" data-testid="pending-approval-screen">
        <CardContent className="pt-10 pb-10 text-center">
          <div className="flex items-center justify-center gap-2 mb-6">
            <Car className="w-7 h-7 text-gold-500" />
            <h1 className="text-2xl font-bold text-white">Black <span className="text-gold-500">HDrive</span></h1>
          </div>
          {rejected ? (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold text-white mb-2">Application Not Approved</h2>
              <p className="text-gray-400 mb-2">Unfortunately, your driver application was not approved at this time.</p>
              {user?.rejection_reason && (
                <p className="text-gray-500 text-sm bg-gray-800 rounded-lg p-3 mt-3" data-testid="rejection-reason">
                  <strong>Note:</strong> {user.rejection_reason}
                </p>
              )}
              <p className="text-gray-500 text-sm mt-4">If you have questions, please contact our team.</p>
            </>
          ) : (
            <>
              <Clock className="w-16 h-16 text-gold-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold text-white mb-2">Application Under Review</h2>
              <p className="text-gray-400">Thanks for applying, {user?.name}! Our team is reviewing your application and documents. You'll receive an email once you're approved.</p>
              <Button data-testid="check-status-button" onClick={() => window.location.reload()} variant="outline" className="mt-6 border-gray-700 text-gray-300 hover:bg-gray-800">
                <RefreshCw className="w-4 h-4 mr-2" /> Check Status
              </Button>
            </>
          )}
          <Button data-testid="pending-logout-button" onClick={logout} variant="ghost" className="mt-4 text-gray-500 hover:text-white w-full">
            <LogOut className="w-4 h-4 mr-2" /> Log Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
